import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import authSlice from 'redux/slices/auth/authSlice';
import userSlice from 'redux/slices/user/userSlice';
import givingBasketSlice from 'redux/slices/baskets/givingBasketSilce';
import suspendBasketSlice from 'redux/slices/baskets/suspendBasketSlice';
import paymentBasketSlice from 'redux/slices/baskets/paymentBasketSlice';
import basketDetailSlice from 'redux/slices/baskets/basketDetailsSlice';
import announcementsSlice from 'redux/slices/announcements/announcementsSlice';
import parishMemberSlice from 'redux/slices/community/parishMemberSlice';
import parishSlice from 'redux/slices/parishesAndOrganisations/parishOrganizationSlice';
import announcementGroupSlice from 'redux/slices/announcements/announcementGroupSlice';
import announcementGroupDetailSlice from 'redux/slices/announcements/announcementGroupDetailSlice';
import walletInvoicesSlice from 'redux/slices/wallet/walletInvoicesSlice';
import walletInvoiceDetailSlice from 'redux/slices/wallet/WalletInvoiceDetailSlice';
import moneyContainerSlice from 'redux/slices/wallet/moneyContainerSlice';
import parishMemberDetailSlice from 'redux/slices/community/parishMemberDetailSlice';
import parishDetailsSlice from 'redux/slices/parishesAndOrganisations/parishDetailsSlice';
import walletActivitySlice from 'redux/slices/wallet/walletActivitySlice';
import staffSlice from 'redux/slices/staff/staffSlice';
import HistorySlice from 'redux/slices/history/HistorySlice';
import merchantBalanceSlice from 'redux/slices/wallet/merchantBalanceSlice';
import qrCodeSlice from 'redux/slices/qr/qrCodeSlice';
import appSlice from 'redux/slices/common/appSlice';
import announcementDetailSlice from './slices/announcements/announcementDetailSlice';
import { RESET_REDUX } from 'redux/action/resetState';
import parishUsersSlice from 'redux/slices/user/parishUsers';
import sendAnnouncementSlice from 'redux/slices/announcements/sendAnnouncementSlice';
import inactiveBasketsSlice from './slices/baskets/inactiveBasketsSlice';
import transactionDetailsSlice from './slices/transaction/transactionDetails';
import stripeOnboardingSlice from 'redux/slices/payments/stripeOnboardingSlice';
import reportsSlice from 'redux/slices/reports/reportsSlice';
import { notificationMiddleware } from './middlewares/notificationMiddleware';

const persistConfig = {
    key: 'root',
    storage: storage,
};

const community = combineReducers({
    perishMembers: parishMemberSlice,
    parishionerDetails: parishMemberDetailSlice,
});
// add seprate combineReducer of notification screen

const announcement = combineReducers({
    announcementsList: announcementsSlice,
    announcementGroups: announcementGroupSlice,
    announcementGroupDetail: announcementGroupDetailSlice,
    announcementDetails: announcementDetailSlice,
    sendAnnouncement: sendAnnouncementSlice,
});

const wallet = combineReducers({
    walletInvoices: walletInvoicesSlice,
    walletInvoiceDetails: walletInvoiceDetailSlice,
    moneyContainer: moneyContainerSlice,
    walletActivity: walletActivitySlice,
    merchantBalance: merchantBalanceSlice,
});

const staff = combineReducers({
    staffList: staffSlice,
});

const parish = combineReducers({
    parishesList: parishSlice,
    parishDetails: parishDetailsSlice,
});
const baskets = combineReducers({
    givingList: givingBasketSlice,
    paymentList: paymentBasketSlice,
    suspendList: suspendBasketSlice,
    details: basketDetailSlice,
    inactiveList: inactiveBasketsSlice,
});
const rootReducer = combineReducers({
    auth: authSlice,
    user: userSlice,
    baskets,
    community,
    parish,
    announcement,
    staff,
    wallet,
    history: HistorySlice,
    qrCode: qrCodeSlice,
    app: appSlice,
    parishUsers: parishUsersSlice,
    transaction: transactionDetailsSlice,
    stripeOnboarding: stripeOnboardingSlice,
    reports: reportsSlice,
});
const appReducer = (state: any, action: any) => {
    if (action.type === RESET_REDUX) {
        // Call the rootReducer with undefined state and action for logout
        return rootReducer(undefined, action);
    }
    // For other actions, call the rootReducer with state and action
    return rootReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, appReducer);
export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(notificationMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
